export { default as LifestylesIndexPageCategoriesNavHead } from './LifestylesIndexPageCategoriesNavHead';
